import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/FavoriteArticlesSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.favorite || initialState;

export const selectArticleAdded = createSelector(
  [selectDomain],
  (state) => state.articleAddedInFavourites,
);

export const selectPage = createSelector(
  [selectDomain],
  (state) => state.favoriteArticlesPage,
);

export const selectArticleLoading = createSelector(
  [selectDomain],
  (state) => state.favoriteArticlesLoading,
);

export const selectPaginationLoader = createSelector(
  [selectDomain],
  (state) => state.paginationLoader,
);

export const selectArticles = createSelector(
  [selectDomain],
  (state) => state.favoriteArticles,
);

export const selectArticlesEnded = createSelector(
  [selectDomain],
  (state) => state.favoriteArticlesEnded,
);

export const selectNextCall = createSelector(
  [selectDomain],
  (state) => state.nextCall,
);
